module.exports = __webpack_public_path__ + "img/1280x720-Nature.27e812d3.jpg";